import { Box, Button, DialogBody, Link, Separator, Stack, Text } from "@chakra-ui/react";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { UI } from "components";
import { useColorMode } from "components/ui-old/color-mode";
import useCart from "hooks/useCart";

export default function Distributor({ ...props }){

    const cart = useCart()
    const distributor = cart.data?.distributor_from
    const colorMode = useColorMode()

    const handleDirections = () => window.open(`https://www.google.com/maps/dir/?api=1&destination=${distributor?.lat},${distributor?.lng}`)

    return(
    <UI.Dialog title={distributor?.name} {...props}>
        <DialogBody>
            <Stack gap={4}>

                <Box>
                    <Text color="GrayText" children="Localização:" />
                    <Text children={`${distributor?.city?.name}, ${distributor?.city?.state_code}`} />
                </Box>

                <Box>
                    <Text color="GrayText" children="Endereço:" />
                    <Text children={`${distributor?.address_line_1}, ${distributor?.address_number} ${distributor?.address_neighborhood}`} />
                    <Text children={`${distributor?.zip} - ${distributor?.address_complement}`} />
                </Box>

                <Separator />

                <Box>
                    <Text color="GrayText" children="E-mail:" />
                    <Link href={`mailto:${distributor?.email}`}><Text children={`${distributor?.email}`} /></Link>
                </Box>

                <Box>
                    <Text color="GrayText" children="Telefone de atendimento:" />
                    <Link target="_blank" href={`https://api.whatsapp.com/send?phone=${distributor?.mobile}`}><Text children={`${distributor?.mobile}`} /></Link>
                </Box>

                <UI.Pressable onClick={handleDirections}>
                    <APIProvider apiKey="AIzaSyD0H9SsIRjE8mdlEKtPRRWElxzRzHtAqbg">
                        <Map
                            reuseMaps
                            controlled
                            style={{width: '100%', height: '180px', borderRadius: '10%' }}
                            center={{lat: distributor?.lat ?? 1, lng: distributor?.lng ?? 1 }}
                            zoom={10}
                            gestureHandling={'greedy'}
                            disableDefaultUI={true}
                            colorScheme={colorMode.colorMode === 'dark' ? 'DARK' : 'LIGHT'}
                            
                        >
                            <Marker
                                position={{lat: distributor?.lat, lng: distributor?.lng }}
                                clickable={false}
                            />
                        </Map>
                    </APIProvider>
                </UI.Pressable>

                <Button size="sm" variant="ghost" onClick={() => props?.onClose()}><UI.Icon name="close" /> Fechar informações</Button>
            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}